import React, { createContext, useContext, useMemo } from 'react';

import { useAuthModal } from '../hooks/useAuthModal';

type AuthModalContextType = ReturnType<typeof useAuthModal>;

const AuthModalContext = createContext<AuthModalContextType | null>(null);

export const AuthModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const authModal = useAuthModal();

  const value = useMemo(() => authModal, [authModal]);

  return (
    <AuthModalContext.Provider value={value}>
      {children}
    </AuthModalContext.Provider>
  );
};

export const useAuthModalContext = (): AuthModalContextType => {
  const context = useContext(AuthModalContext);

  if (!context) {
    throw new Error('useAuthModalContext must be used within AuthModalProvider');
  }

  return context;
};
